export const storeInLocalStorage = (content: any, name: string) => {
  content = JSON.stringify(content);
  window.localStorage.setItem(name, content);
};
